export function setSearchParam(key, value) {
    const url = new URL(window.location.href);

    url.searchParams.set(key, value);

    // Update the browser's URL without causing a page reload
    window.history.pushState({}, '', url.toString());
}

export function getSearchParam(key, defaultValue = null) {
    const url = new URL(window.location.href);

    return url.searchParams.get(key) ?? defaultValue;
}


export function removeSearchParam(key) {
    const url = new URL(window.location.href);

    url.searchParams.delete(key);

    // Update the browser's URL without causing a page reload
    window.history.pushState({}, '', url.toString());
}
